export default "__VITE_ASSET__9b402884__"